import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/web.timers.js";
import axios from 'axios';
var CryptoJS = require("crypto-js");
import { defineComponent } from 'vue';
import LoaderComponent from './LoaderComponent.vue';
// import ImageCarousel from "./chunks/ImageCarousel.vue";
export default defineComponent({
  name: 'NewLogin',
  components: {
    LoaderComponent: LoaderComponent
    // ImageCarousel
    //components
  },
  setup: function setup() {
    return {
      //setup
    };
  },
  watch: {
    'showLogin': 'addWatcher',
    '$store.state.loginSelector': 'stepAction'
    //watch
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var pass2;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log('<<<<<<<<< NewLogin mounted >>>>>>>>>');
            _this.turnOffShowPasswordReset();
            _this.showForgotPassword = false;
            _this.showLogin = true;
            _this.showRegistration = true;
            _this.message = '';
            _this.$store.commit('updateShowUserLogin', false);
            //mounted
            _this.showLogin = false;
            _this.showRegistration = true;
            if (_this.$store.state.showLoginPage) {
              _this.showLogin = false;
              _this.showRegistration = true;
            }
            pass2 = document.getElementById('password2');
            if (pass2 && pass2.addEventListener) {
              pass2.addEventListener('keyup', function (e) {
                if (e.key === 'Enter') {
                  _this.register();
                }
              });
            }
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  props: {
    //props
  },
  data: function data() {
    return {
      introSlides: [{
        image: "assets/web/allavatars.webp",
        topTitle: "Welcome & Thank You!",
        topSummary: "",
        header: "",
        description: "\n          <div style='text-align:left' class='writing'>\n            <div style=\"margin-top: 20px;\"></div>\n            I am so excited you've decided to try this app. \n          \n          <div style=\"margin-top: 10px;\"></div>\n          This has been in development for ..<i>awhile now</i>. I've actually been working on it for <b><i>over 14 months</i></b> working on it day and night...relentlessly.\n          <div style=\"margin-top: 10px;\"></div>\n          I've sacrificed time with my kids, friends and family, holidays and probably even promotions at work.\n          <div style=\"margin-top: 10px;\"></div>\n          I just knew I had to build this and bring it to the masses.\n\n          <div style=\"margin-top: 10px;\"></div>\n          It's not perfect just yet and there is <b><i>SO MUCH MORE coming!</i></b> But I think you'll enjoy it though and we can continue to grow with it together. <div class='yellow'>Running the app is not cheap. Currently this app is costing me over $20k a year to run <i><b>and climbing</b></i> so please support this app where you can or share it with the world.</div> \n          <img style='text-align:left;margin-top:-20px; height:100px;width:auto;position:absolute;right:-10%;z-index:99999;' src='assets/signature.webp' />\n       </div>\n           ",
        imageStyles: {
          height: "auto",
          width: "100%",
          "max-height": "180px",
          "object-fit": "cover"
        }
      }, {
        image: "assets/web/avatarSelector/mary.webp",
        topTitle: "The Goal",
        // topSummary: 'I am so excited you\'ve decided to try this app. This app has been in development for over a year now by a single developer working on this in my spare time.',
        header: "",
        description: "\n          <div style='text-align:left; z-index:10;'>\n            <div style=\"margin-top: 20px;\"></div>\n                  The goal of this app is to make  <b><i>the most realistic digital people imaginable</i></b> and provide a compelling, robust experience that caters to the needs of the user.\n           ",
        // description: 'I\'ve had the ability to talk with AI for a while not but I wanted to build something to bring this to the people.',
        imageStyles: {
          "height": "300px",
          "width": "auto",
          "margin": '0 auto'
        }
      }, {
        image: "assets/web/avatarSelector/kurt.webp",
        topTitle: "Acknowledgement",
        // topSummary: 'I am so excited you\'ve decided to try this app. This app has been in development for over a year now by a single developer working on this in my spare time.',
        header: "",
        description: "\n          <div style='text-align:left; z-index:10;'>\n            <div style=\"margin-top: 20px;\"></div>\n                  While I've gone to great lengths making them as real as possible(still a work in progress though!). <span style=\"color:#a30202\"> Howerver, it's important that you understand that they <b><i>are not real people ...no matter what they tell you.</i></b> \n            </span>\n          <div style=\"margin-top: 20px;\"></div>\n          <div  class=\"yellow\">\n          Please understand that they <b><i>don't have a conscious</i></b>, nor are they <b><i>self aware</i></b> but they may seem really ..<b><i>really real</i></b> when you talk to them.\n          </div> ",
        // description: 'I\'ve had the ability to talk with AI for a while not but I wanted to build something to bring this to the people.',
        imageStyles: {
          "height": "300px",
          "width": "auto",
          "margin": '0 auto'
        },
        nextButtonLabel: "Got it",
        nextButtonIcon: ["fa", "check"]
      }, {
        //     image: "assets/web/avatarSelector/mary.webp",
        //     topTitle: "So many possibilities",
        //     // topSummary: 'I am so excited you\'ve decided to try this app. This app has been in development for over a year now by a single developer working on this in my spare time.',
        //     header: "",
        //     description: `
        //   <div style='text-align:left; z-index:10;'>
        //     <div style="margin-top: 20px;"></div>
        //           Now, we can get onto the fun stuff. Please let us know your feedback on this intro and the app experience in general by joining our discord.
        //     </span>
        //   <div style="margin-top: 20px;"></div>
        //   <b><i>Okay, let's get past the terms and conditions and get started!</i></b>
        //    `,
        //     // description: 'I\'ve had the ability to talk with AI for a while not but I wanted to build something to bring this to the people.',
        //     imageStyles: {
        //       height: "500px",
        //       width: "auto",
        //       "max-height": "350px",

        //       // "object-fit": "cover",
        //     },
        hidePreviousButton: true,
        hideNextButton: true
      }],
      showPassword: false,
      showLoader: false,
      message: '',
      axios: axios,
      showLogin: false,
      showRegistration: true,
      showVerification: false,
      showRedirectToCheckout: false,
      firstname: '',
      lastname: '',
      email: '',
      password: '',
      passwordVerify: '',
      city: '',
      state: '',
      zip: '',
      phone: '',
      address1: '',
      address2: '',
      country: '',
      emailError: false,
      passwordError: false,
      firstnameError: false,
      lastnameError: false
    };
  },
  methods: {
    stepAction: function stepAction() {
      var step = this.$store.state.loginSelector;
      var data = '';
      if (step === 0) {
        data = 'Thank You';
      }
      if (step === 1) {
        data = 'The Goal';
        this.$store.dispatch('startRecording');
      }
      if (step === 2) {
        data = 'Acknowledge';
      }
      if (step === 3) {
        data = 'Register';
      }
      this.$store.dispatch("registerActionEvent", {
        action: "prelogin",
        data: data
      });
      return '';
    },
    addWatcher: function addWatcher() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.emailError = false;
              _this2.passwordError = false;
              _this2.firstnameError = false;
              _this2.lastnameError = false;
              setTimeout(function () {
                try {
                  var pass1 = document.getElementByClassName('passwordInput');
                  pass1.addEventListener('keyup', function (e) {
                    if (e.key === 'Enter') {
                      _this2.userLogin();
                      // do not focus on input now
                      pass1.blur();
                    }
                  });
                } catch (error) {
                  console.log(error);
                }
              }, 1000);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    turnOffShowPasswordReset: function turnOffShowPasswordReset() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.$store.commit('updateShowPasswordReset', false);
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    resetMyPassword: function resetMyPassword() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var encryptDetailsForTransit, myToken, data, config, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(_this4.password != _this4.passwordVerify)) {
                _context4.next = 3;
                break;
              }
              _this4.message = 'Passwords do not match, please check them and try again';
              return _context4.abrupt("return");
            case 3:
              _this4.showLoader = true;
              _context4.next = 6;
              return _this4.encryptDetailsForTransit('not set', _this4.password);
            case 6:
              encryptDetailsForTransit = _context4.sent;
              myToken = window.location.href.split('token=')[1];
              data = {
                token: myToken,
                password: encryptDetailsForTransit.intransitPassword
              };
              config = {
                method: 'post',
                url: "https://us-central1-ai-voice-chat-358705.cloudfunctions.net/resetMyPassword",
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: data
              };
              _context4.next = 12;
              return axios(config);
            case 12:
              response = _context4.sent;
              console.log(response);
              _this4.showLoader = false;
              if (response && response.data && response.data.message) {
                _this4.message = response.data.message;
              }
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    storeToken: function storeToken(token) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (_this5.storageAvailable('localStorage')) {
                console.log('storing token');
                localStorage.setItem('security', token);
              }
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    getToken: function getToken() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!_this6.storageAvailable('localStorage')) {
                _context6.next = 3;
                break;
              }
              console.log('getting token');
              return _context6.abrupt("return", localStorage.getItem('security'));
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    storageAvailable: function storageAvailable(type) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var storage, x;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              storage = window[type];
              x = '__storage_test__';
              storage.setItem(x, x);
              storage.removeItem(x);
              return _context7.abrupt("return", true);
            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);
              return _context7.abrupt("return", _context7.t0 instanceof DOMException && (
              // everything except Firefox
              _context7.t0.code === 22 ||
              // Firefox
              _context7.t0.code === 1014 ||
              // test name field too, because code might not be present
              // everything except Firefox
              _context7.t0.name === 'QuotaExceededError' ||
              // Firefox
              _context7.t0.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
              // acknowledge QuotaExceededError only if there's something already stored
              storage && storage.length !== 0);
            case 11:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[0, 8]]);
      }))();
    },
    encryptDetailsForTransit: function encryptDetailsForTransit(email, passwordIncoming) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var password, intransitPassword, intransitEmail;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              password = passwordIncoming + '!!!!@!!!!';
              intransitPassword = CryptoJS.AES.encrypt(password, '345678dfs90@#$%^&3456@34567*@#$567WERT3456&34567*#$%^&*34%^&*345^&#$%^&*ewrty#$%^&*dfgh#$%^&* ').toString();
              intransitEmail = CryptoJS.AES.encrypt(email, '345678dfs90@#$%^&3456@34567*@#$567WERT3456&34567*#$%^&*34%^&*345^&#$%^&*ewrty#$%^&*dfgh#$%^&* ').toString();
              return _context8.abrupt("return", {
                intransitEmail: intransitEmail,
                intransitPassword: intransitPassword
              });
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    userLogin: function userLogin() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var email, password, encryptedData, data, config, response;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.t0 = _this7.email.length < 4;
              if (_context9.t0) {
                _context9.next = 5;
                break;
              }
              _context9.next = 4;
              return _this7.validateEmailFormat();
            case 4:
              _context9.t0 = !_context9.sent;
            case 5:
              if (!_context9.t0) {
                _context9.next = 8;
                break;
              }
              _this7.message = 'Please enter a valid email address';
              return _context9.abrupt("return");
            case 8:
              _context9.prev = 8;
              _this7.showLoader = true;
              _this7.message = '';
              email = _this7.email;
              _this7.$store.commit('updateUserEmail', email);
              password = _this7.password;
              _context9.next = 16;
              return _this7.encryptDetailsForTransit(email, password);
            case 16:
              encryptedData = _context9.sent;
              console.log('intransitEmail', encryptedData.intransitEmail);
              console.log('intransitPassword', encryptedData.intransitPassword);
              data = {
                'password': encryptedData.intransitPassword,
                'email': encryptedData.intransitEmail
              };
              config = {
                method: 'post',
                url: "".concat(_this7.$store.state.systemRoute, "/userLogin"),
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: data
              };
              _context9.prev = 21;
              _context9.next = 24;
              return axios(config);
            case 24:
              response = _context9.sent;
              _context9.next = 32;
              break;
            case 27:
              _context9.prev = 27;
              _context9.t1 = _context9["catch"](21);
              console.log('error', _context9.t1);
              _this7.showLoader = false;
              _this7.message = 'Check username or password and try again';
            case 32:
              console.log('response', response);
              _this7.showLoader = false;
              if (response && response.data && response.data.success && response.data.token) {
                _this7.storeToken(response.data.token);
                // should be good to do stuff now 
                // this.checkMembership();
                _this7.$store.commit('updateLoginDetected', true);
                _this7.$store.dispatch('getProfile');
              } else {
                if (response && response.message) {
                  _this7.message = response.message;
                }
              }
              _context9.next = 42;
              break;
            case 37:
              _context9.prev = 37;
              _context9.t2 = _context9["catch"](8);
              console.log('error', _context9.t2);
              _this7.showLoader = false;
              if (_context9.t2 && _context9.t2.response && _context9.t2.response.data && _context9.t2.response.data.message) {
                _this7.message = _context9.t2.response.data.message;
              }
            case 42:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[8, 37], [21, 27]]);
      }))();
    },
    validateEmailFormat: function validateEmailFormat() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var email, emailRegex;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              email = _this8.email;
              emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (!emailRegex.test(email)) {
                _context10.next = 6;
                break;
              }
              return _context10.abrupt("return", true);
            case 6:
              return _context10.abrupt("return", false);
            case 7:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    requestPasswordReset: function requestPasswordReset() {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var email, encryptedData, data, config, response;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.t0 = _this9.email.length < 4;
              if (_context11.t0) {
                _context11.next = 5;
                break;
              }
              _context11.next = 4;
              return _this9.validateEmailFormat();
            case 4:
              _context11.t0 = !_context11.sent;
            case 5:
              if (!_context11.t0) {
                _context11.next = 8;
                break;
              }
              _this9.message = 'Please enter a valid email address';
              return _context11.abrupt("return");
            case 8:
              _context11.prev = 8;
              _this9.showLoader = true;
              _this9.message = '';
              email = _this9.email;
              _context11.next = 14;
              return _this9.encryptDetailsForTransit(email, 'no password');
            case 14:
              encryptedData = _context11.sent;
              console.log('intransitEmail', encryptedData.intransitEmail);
              data = {
                'email': encryptedData.intransitEmail
              };
              config = {
                method: 'post',
                url: "https://us-central1-ai-voice-chat-358705.cloudfunctions.net/passwordReset",
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: data
              };
              _context11.prev = 18;
              _context11.next = 21;
              return axios(config);
            case 21:
              response = _context11.sent;
              _this9.showLoader = false;
              response = response.data;
              _context11.next = 31;
              break;
            case 26:
              _context11.prev = 26;
              _context11.t1 = _context11["catch"](18);
              console.log('error', _context11.t1);
              _this9.showLoader = false;
              if (_context11.t1 && _context11.t1.message) {
                _this9.message = _context11.t1.message;
              } else {
                _this9.message = 'Server Seems offline or responded with an error, please try again later';
              }
            case 31:
              console.log('response', response);
              if (response && response.data && response.data.success && response.data.message) {
                _this9.message = response.message;
              } else {
                if (response && response.message) {
                  _this9.message = response.message;
                }
              }
              _context11.next = 40;
              break;
            case 35:
              _context11.prev = 35;
              _context11.t2 = _context11["catch"](8);
              console.log('error', _context11.t2);
              _this9.showLoader = false;
              if (_context11.t2 && _context11.t2.response && _context11.t2.response.data && _context11.t2.response.data.message) {
                _this9.message = _context11.t2.response.data.message;
              }
            case 40:
            case "end":
              return _context11.stop();
          }
        }, _callee11, null, [[8, 35], [18, 26]]);
      }))();
    },
    //methods
    register: function register() {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var errorMessage, email, encryptedData, billingPlatform, data, config, response, hasEmailIssue, hasPasswordIssue;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this10.$store.dispatch("registerActionEvent", {
                action: "prelogin",
                data: 'Trying to register'
              });
              errorMessage = '';
              if (_this10.firstname.length < 3) {
                _this10.firstnameError = '* Required';
                errorMessage = 'Please enter a first name';
              } else if (_this10.firstname.length > 25) {
                _this10.firstnameError = '(name is too long)';
                errorMessage = 'Please check first name';
              } else {
                _this10.firstnameError = null;
              }
              _context12.t0 = _this10.email.length < 4;
              if (_context12.t0) {
                _context12.next = 8;
                break;
              }
              _context12.next = 7;
              return _this10.validateEmailFormat();
            case 7:
              _context12.t0 = !_context12.sent;
            case 8:
              if (!_context12.t0) {
                _context12.next = 13;
                break;
              }
              _this10.emailError = '* Required';
              if (errorMessage.length > 0) {
                errorMessage += ', enter valid email address';
              } else {
                errorMessage = 'Please enter a valid email address';
              }
              _context12.next = 14;
              break;
            case 13:
              _this10.emailError = null;
            case 14:
              if (_this10.password.length < 8) {
                _this10.passwordError = '* Required';
                if (errorMessage.length > 0) {
                  errorMessage += ' and a valid password';
                } else {
                  errorMessage = 'Please enter a valid password';
                }
              } else {
                _this10.passwordError = null;
              }
              if (!(errorMessage.length > 0)) {
                _context12.next = 18;
                break;
              }
              _this10.message = errorMessage;
              return _context12.abrupt("return");
            case 18:
              _this10.showLoader = true;
              _this10.message = '';
              email = _this10.email;
              _this10.$store.commit('updateUserEmail', email);
              _context12.next = 24;
              return _this10.encryptDetailsForTransit(_this10.email, _this10.password);
            case 24:
              encryptedData = _context12.sent;
              console.log('intransitEmail', encryptedData.intransitEmail);
              console.log('intransitPassword', encryptedData.intransitPassword);
              billingPlatform = 'web';
              if (process.env.VUE_APP_ANDROID) {
                billingPlatform = 'android';
              }
              data = {
                'password': encryptedData.intransitPassword,
                'email': encryptedData.intransitEmail,
                'billingPlatform': billingPlatform,
                'firstname': _this10.firstname,
                'lastname': _this10.lastname
                // 'subscriptionType': this.$store.state.subscriptionType
              }; // get current domain with http
              // var domain = window.location.href.split('/').slice(0, 3).join('/');
              config = {
                method: 'post',
                url: "".concat(_this10.$store.state.systemRoute, "/registerAccount"),
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: data
              };
              _context12.prev = 31;
              _context12.next = 34;
              return axios(config);
            case 34:
              response = _context12.sent;
              console.log('response', response);
              _this10.showLoader = false;
              if (response && response.message) {
                _this10.message = response.message;
              }
              if (response && response.data && response.data.success && response.data.uid) {
                try {
                  window.fbq('track', 'Lead');
                } catch (error) {
                  console.log('error in fbq track lead', error);
                }
                _this10.$store.dispatch("registerActionEvent", {
                  action: "prelogin",
                  data: 'registered'
                });
                _this10.$store.commit('updateUserUID', response.data.uid);
                _this10.$store.dispatch('crazyEggUserLoggedIn');
                if (response.data.token) {
                  _this10.storeToken(response.data.token);
                  console.log('token should have been stored');
                  _this10.$store.dispatch("registerActionEvent", {
                    action: "prelogin",
                    data: 'token provided'
                  });
                }
                _this10.$store.commit('updateShowExperienceSelector', true);
                _this10.$store.commit("updateShowMainApplication", true);
                _this10.$store.commit('updateNewUserDetected', true);
                // this.$store.dispatch('crazyEggStopRecording');
                // this.$store.commit('updateShowUserLogin', false);
              }
              _context12.next = 47;
              break;
            case 41:
              _context12.prev = 41;
              _context12.t1 = _context12["catch"](31);
              console.log('error', _context12.t1);
              _this10.$store.dispatch("registerActionEvent", {
                action: "prelogin",
                data: 'login error'
              });
              if (_context12.t1 && _context12.t1.response && _context12.t1.response.data) {
                if (_context12.t1.response.data.message) {
                  _this10.message = _context12.t1.response.data.message;
                } else {
                  _this10.message = 'Please check your details and try again.';
                }
                if (_context12.t1.response.data.errorItems && Array.isArray(_context12.t1.response.data.errorItems)) {
                  hasEmailIssue = false; // let hasFirstnameIssue=false;
                  // let hasLastnameIssue=false;
                  hasPasswordIssue = false;
                  _context12.t1.response.data.errorItems.forEach(function (item) {
                    if (item.issue === 'email') {
                      hasEmailIssue = true;
                      _this10.emailError = '* ' + item.message;
                    }
                    if (item.issue === 'password') {
                      hasPasswordIssue = true;
                      _this10.passwordError = '* ' + item.message;
                    }
                    // if(item.issue === 'firstname'){
                    //     hasFirstnameIssue=true;
                    //     this.firstnameError = '* ' + item.message;
                    // }
                    // if(item.issue === 'lastname'){
                    //     hasLastnameIssue=true;
                    //     this.lastnameError = '* ' + item.message;
                    // }
                  });
                  if (!hasEmailIssue) {
                    _this10.emailError = false;
                  }
                  if (!hasPasswordIssue) {
                    _this10.passwordError = false;
                  }
                  // if(!hasFirstnameIssue){
                  //     this.firstnameError = false;
                  // }
                  // if(!hasLastnameIssue){
                  //     this.lastnameError = false;
                  // }
                }
              }
              _this10.showLoader = false;
            case 47:
            case "end":
              return _context12.stop();
          }
        }, _callee12, null, [[31, 41]]);
      }))();
    }
  }
});